<template>
  <div class="pages">
    <div class="top-tab">
      <h3>心愿管理</h3>
      <div class="filter">
        <div>
          <el-form size="small" :inline="true">
            <el-form-item label="是否匿名">
              <el-select v-model="formInline.isAnonymous" clearable>
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="毕业年份">
              <el-date-picker
                v-model="formInline.graduationYear"
                value-format="yyyy"
                type="year"
                placeholder="选择年"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
              <el-select
                clearable
                v-model="formInline.School"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="search">
          <el-form size="small" :inline="true">
            <el-form-item label="">
              <el-input
                clearable
                v-model="formInline.Keyword"
                placeholder="请输入关键词查询"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="searchList">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="table">
      <div v-show="activeName == 0">
        <el-button
          v-if="!$store.state.userinfo.isSuper"
          type="primary"
          size="medium"
          @click="setHandle"
          >设置</el-button
        >
        <el-button
          v-if="$store.state.userinfo.isSuper"
          type="primary"
          size="medium"
          @click="schoolSetHandle"
          >学校设置</el-button
        >
        <el-table
          :data="tableData"
          @selection-change="handleSelectionChange"
          height="4.92rem"
          max-height="4.92rem"
          style="width: 100%"
        >
          <el-table-column
            show-overflow-tooltip
            property="userName"
            label="提交人"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="school"
            label="所属学校"
            align="center"
            width="140"
          >
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            property="schoolName"
            label="学院"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.schoolName">{{
                scope.row.schoolName
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="major"
            label="专业"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.major">{{ scope.row.major }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="qualification"
            label="学历层次"
            align="center"
            width="150"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.qualification">{{ scope.row.qualification }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="graduateYear"
            label="毕业年份"
            align="center"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.graduateYear">{{ scope.row.graduateYear }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            property="wishTitle"
            label="心愿标题"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="wishContext"
            label="心愿内容"
            align="center"
            width="260"
          >
          </el-table-column>
          <el-table-column property="isNM" label="是否匿名" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isNM">是</span>
              <span v-if="!scope.row.isNM">否</span>
            </template>
          </el-table-column>
          <el-table-column property="isXS" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isXS" size="small" type="info"
                >失效</el-tag
              >
              <el-tag v-if="!scope.row.isXS" size="small">正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="see(scope.row, 0)" type="text" size="medium"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="activeName == 1">
        <el-table :data="tableData" height="5.28rem" max-height="5.28rem">
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            property="userName"
            label="预约人姓名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            property="college"
            label="学院"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column property="major" label="专业" align="center">
          </el-table-column>

          <el-table-column
            label="毕业年份"
            property="graduationYear"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            property="createTime"
            label="预约时间"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column property="carNumber" label="车牌号" align="center">
          </el-table-column>
          <el-table-column
            property="togetherPersonCount"
            label="随行人数"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="retuenSchoolReason"
            label="返校事由"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="createTime"
            label="提交时间"
            align="center"
            width="260"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="auditTime"
            label="审核时间"
            align="center"
            width="260"
          >
          </el-table-column>
          <el-table-column
            property="prebookState"
            label="预约状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.prebookState === 0" size="small"
                >待核验</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 1"
                size="small"
                type="info"
                >已取消</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 2"
                size="small"
                type="danger"
                >未通过</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 3"
                size="small"
                type="success"
                >已核验</el-tag
              >
              <el-tag
                v-if="scope.row.prebookState === 4"
                size="small"
                type="danger"
                >未返校</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="verifyCount"
            label="检验次数"
            align="center"
          >
            <template #default="{ row }">
              {{ row.verifyCount === 0 ? "暂无" : row.verifyCount }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="see(scope.row, 1)" type="text" size="medium"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <setDialog
      :showDialog="setDialogVisible"
      @closeSetDialog="closeSetDialog"
    />

    <el-dialog
      title="学校设置"
      :visible.sync="schoolSetDialogVisible"
      :before-close="handleClose"
    >
      <div class="search">
        <el-form size="small" :inline="true">
          <el-form-item label="">
            <el-input
              clearable
              v-model="schoolVal.keyword"
              placeholder="请输入关键词查询"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="searchList2">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="adminList">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column
          property="schoolName"
          align="center"
          label="学校名称"
          width="200"
        ></el-table-column>
        <el-table-column
          property="adminNames"
          align="center"
          label="学校教职工管理员"
        ></el-table-column>
        <el-table-column property="address" align="center" label="是否开启匿名">
          <template slot-scope="scope">
            <span v-if="scope.row.configValue">是</span>
            <span v-if="!scope.row.configValue">否</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-drawer
      size="45%"
      :title="handleType === 0 ? '心愿详情' : '查看'"
      :visible.sync="centerDialogVisible"
      direction="rtl"
      class="judge-pop"
    >
      <div class="info">
        <el-descriptions title="" column="1">
          <el-descriptions-item label="是否匿名">{{
            currStudentInfo.isNM ? "是" : "否"
          }}</el-descriptions-item>
          <el-descriptions-item v-if="!currStudentInfo.isNM" label="提交人">{{
            `${currStudentInfo.userName}`
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="学院专业">{{
            `${currStudentInfo.schoolName}-${currStudentInfo.major}`
          }}</el-descriptions-item>
          <el-descriptions-item label="学历层次">{{
            currStudentInfo.qualification
          }}</el-descriptions-item>
          <el-descriptions-item label="毕业年份">{{
            currStudentInfo.graduateYear
          }}</el-descriptions-item> -->
          <el-descriptions-item label="标题">{{
            currStudentInfo.wishTitle
          }}</el-descriptions-item>
          <el-descriptions-item label="内容">{{
            currStudentInfo.wishContext
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="info">
        <el-descriptions title="其他信息" column="1">
          <el-descriptions-item label="提交时间">
            {{ currStudentInfo.createTime }}
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag v-if="currStudentInfo.isXS" size="small" type="info"
              >失效</el-tag
            >
            <el-tag v-if="!currStudentInfo.isXS" size="small">正常</el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="other-info">
        <el-descriptions title="用户信息" column="1">
          <el-descriptions-item label="用户名">
            {{ currStudentInfo.userName }}
          </el-descriptions-item>
          <el-descriptions-item label="所属学校">
            {{ currStudentInfo.school }}
          </el-descriptions-item>
          <el-descriptions-item label="学院专业" v-if="currStudentInfo.userType!=1">
            {{ currStudentInfo.faculty?currStudentInfo.faculty:currStudentInfo.schoolName + '-' + currStudentInfo.major }}
          </el-descriptions-item>
           <el-descriptions-item label="学历层次" v-if="currStudentInfo.userType==0">
            {{ currStudentInfo.qualification }}
          </el-descriptions-item>
          <el-descriptions-item label="毕业年份" v-if="currStudentInfo.userType==0">
            {{ currStudentInfo.graduateYear }}
          </el-descriptions-item>
          <el-descriptions-item label="校内职务" v-if="currStudentInfo.userType==1">
            {{ currStudentInfo.schoolJob?currStudentInfo.schoolJob:'-' }}
          </el-descriptions-item>
          <el-descriptions-item label="所属院系" v-if="currStudentInfo.userType==1">
            {{ currStudentInfo.faculty?currStudentInfo.faculty:'-' }}
          </el-descriptions-item>
          <el-descriptions-item label="具体职位" v-if="currStudentInfo.userType==1">
            {{ currStudentInfo.job?currStudentInfo.job:'-' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import education from "../../components/userDetail/education.vue"; //教育经历认证
import setDialog from "./components/setDialog.vue";
import {
  GetNM_adminApi,
  GetWishListAsync_adminApi,
  GetReturnSchoolPrebooksRecordApi,
  AuditReturnSchoolPrebookApi,
  GetWishInfo_adminApi
} from "@/request/requestApi.js";
export default {
  data() {
    return {
      adminList: [],
      //学校
      schoolList: [],
      handleType: 0,
      setDialogVisible: false,
      schoolSetDialogVisible: false,
      activeName: 0,
      centerDialogVisible: false,
      tableData: [],
      judgeTableData: [],
      formInline: {
        School: null,
        Keyword: null,
        isAnonymous: null,
        IsTogether: null,
        graduationYear: null,
        PrebookState: null
      },
      schoolVal: {
        keyword: null
      },
      //学生信息
      // currStudentInfo: [],
      currStudentInfo: {
        returnSchoolPrebookVerify: [],
        returnSchoolPrebookTogetherPerson: []
      },
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //多选框
      multipleSelection: [],
      //批量审核id
      judIds: []
    };
  },
  created() {
    this.getReturnRecordList();
    this.getSchoolList();
  },
  mounted() {},
  methods: {
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    reject() {
      this.$prompt("确认驳回申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "请填写理由"
      })
        .then(({ value }) => {
          this.adjustStudent([this.currStudentInfo.id], 2, value);
        })
        .catch(() => {});
    },
    submit() {
      this.$confirm("确认通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.adjustStudent([this.currStudentInfo.id], 1);
        })
        .catch(() => {});
    },
    setHandle() {
      this.setDialogVisible = true;
    },
    schoolSetHandle() {
      this.getAdminList();
    },
    async getAdminList() {
      let res = await GetNM_adminApi(this.schoolVal);
      if (res.succeed) {
        this.adminList = res.data;
        this.schoolSetDialogVisible = true;
      }
    },
    closeSetDialog() {
      this.setDialogVisible = false;
    },
    //批量审核
    judStudents() {
      if (this.judIds.length <= 0) {
        this.$message.error("请至少选择一条审核信息！");
        return false;
      }
      this.$confirm("确认批量通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.adjustStudent(this.judIds, 1);
        })
        .catch(() => {});
    },
    //关闭
    close() {
      this.centerDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.judIds = [];
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.multipleSelection.forEach(element => {
        this.judIds.push(element.id);
      });
      console.log(this.judIds);
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.formInline = {
        School: "",
        label: "",
        role: "",
        dataValue: "",
        Keyword: ""
      };
      if (this.activeName == 0) {
        this.getReturnRecordList();
      } else if (this.activeName == 1) {
        this.getHistoryStudentList();
      }
    },
    see(val, type) {
      this.centerDialogVisible = true;
      this.handleType = type;
      this.getStudentInfo(val.id);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      if (this.activeName == 0) {
        this.getReturnRecordList(this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getHistoryStudentList(this.currentPage, this.currentSize);
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      if (this.activeName == 0) {
        this.getReturnRecordList(this.currentPage, this.currentSize);
      } else if (this.activeName == 1) {
        this.getHistoryStudentList(this.currentPage, this.currentSize);
      }
    },
    searchList() {
      this.currentPage = 1;
      this.getReturnRecordList(this.currentPage);
    },
    searchList2() {
      this.getAdminList();
    },
    handleClose() {
      this.schoolVal.keyword = null;
      this.schoolSetDialogVisible = false;
    },
    //获取列表
    async getReturnRecordList(pageIndex = 1, pageSize = 10) {
      const params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        School: this.formInline.School ? this.formInline.School : null,
        isAnonymous: this.formInline.isAnonymous,
        graduationYear: this.formInline.graduationYear,
        Keyword: this.formInline.Keyword ? this.formInline.Keyword : null
      };
      let res = await GetWishListAsync_adminApi(params);

      if (res.succeed) {
        this.tableData = res.data.wishList;
        this.totalCount = res.data.count;
        if (this.tableData.length <= 0 && this.currentPage > 1) {
          this.getReturnRecordList(--this.currentPage);
        }
      } else {
        this.$message.error(res.error);
      }
    },
    searchHistoryList() {
      this.currentPage = 1;
      this.getHistoryStudentList(this.currentPage);
    },
    //获取历史列表
    async getHistoryStudentList(pageIndex = 1, pageSize = 10) {
      const params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        isAnonymous: this.formInline.isAnonymous,
        graduationYear: this.formInline.graduationYear,
        Keyword: this.formInline.Keyword,
        PrebookState: this.formInline.PrebookState,
        IsTogether: this.formInline.IsTogether
      };
      let res = await GetReturnSchoolPrebooksRecordApi(params);
      if (res.succeed) {
        this.tableData = res.data.item1;
        this.totalCount = res.data.item2;
        this.tableData.forEach(element => {
          element.createTime = element.createTime.substring(0, 10);
        });
        console.log(this.tableData);
      } else {
        this.$message.error(res.error);
      }
    },
    //获取学深信息
    async getStudentInfo(currId) {
      let res = await GetWishInfo_adminApi({ IDDto: currId });
      if (res.succeed) {
        // this.currStudentInfo = [];
        // this.currStudentInfo.push(res.data);
        this.currStudentInfo = res.data;
      } else {
        this.$message.error(res.error);
      }
    },
    //审核
    async adjustStudent(currId, state, cancleReason = "") {
      let res = await AuditReturnSchoolPrebookApi({
        id: currId,
        auditState: state,
        auditRemark: cancleReason
      });
      if (res.succeed) {
        this.$message.success("操作成功！");
        this.close();
        this.getReturnRecordList(this.currentPage, this.currentSize);
      } else {
        this.$message.error(res.error);
      }
    },
    //动态获取url
    getUrl(url, queryConfig) {
      //var queryConfig={"page" : "index", "method" : 2}
      var that = this;
      var _str = "";
      for (var obj in queryConfig) {
        if (!that.isNull(queryConfig[obj])) {
          _str += obj + "=" + queryConfig[obj] + "&";
        }
      }
      console.log(_str.length);
      if (_str.length > 0) {
        return url + _str.substring(0, _str.length - 1);
      } else {
        return "";
      }
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    }
  },
  components: {
    setDialog
  }
};
</script>
<style lang="scss" scoped>
.top-tab {
  padding: 0.2rem;
  background-color: #fff;
  border-radius: 10px;
  h3 {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 20px;
    color: #363636;
  }
}
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  // padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
.judge-pop {
  >>> .el-drawer__header span {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
  >>> .el-descriptions-item__container > span {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .state {
    padding: 0.3rem 0.6rem;
    border-bottom: 1px solid #eeeeee;
  }
  .info {
    padding: 0.3rem 0.6rem;
    border-bottom: 1px solid #eeeeee;
    .allow-people {
      margin-top: 0.12rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
      }
      .count {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
    }
    .people-list {
      margin-top: 0.2rem;
      padding: 0.24rem;
      background: #507bf410;
      border-radius: 10px;
      .people-item {
        margin-top: 0.24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .phone,
        .name {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
      }
      .people-item:first-child {
        margin-top: 0 !important;
      }
    }
    .return-reason {
      margin-top: 0.24rem;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      display: flex;
      .reason-text,
      .reason-title {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
      .reason-title {
        white-space: nowrap;
      }
    }
  }
  .judge-info {
    width: 100%;
    padding: 0.3rem 0.6rem;
    padding-top: 0;
    h3 {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
  }
  .other-info {
    padding: 0.3rem 0.6rem;
    // margin-bottom: 30px;
  }
  .judge-section {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    padding: 0.3rem 0.6rem;
    display: flex;
    justify-content: end;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/wishManage/appointment.vue